import { Flame, ShieldHalf, Sparkles, Crown, Gem } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function boostList(boosts, settings) {
  const b = settings.boosts;
  const names = Object.fromEntries(settings.collections.map((c) => [c.key, c.name]));
  return [
    { key: "c1", on: boosts.c1, icon: Flame, name: names.c1, text: `+${b.c1_atk}% Attack & Wolfpack Fury skill`, color: "text-fuchsia-300", sample: "/art/c1_exclusive.webp" },
    { key: "c2", on: boosts.c2, icon: ShieldHalf, name: names.c2, text: `+${b.c2_hpdef}% Health & Defense & Ironhide skill`, color: "text-cyan-300", sample: "/art/sample_c2.webp" },
    { key: "c3", on: boosts.c3, icon: Sparkles, name: names.c3, text: `+${b.c3_xploot}% XP & loot, 1 free revive daily`, color: "text-violet-300", sample: "/art/c3_pups.webp" },
    { key: "sol", on: boosts.sol, icon: Gem, name: "1/1 Wolves (Solana)", text: boosts.sol ? `+${boosts.sol_pct}% to every stat (${boosts.sol_count} held) & a free energy refill daily` : "+5% to every stat per 1/1 Wolf NFT held, up to +25%, plus a free energy refill every day", color: "text-emerald-300", sample: "/brand/mwp_coin.png" },
    { key: "pack", on: boosts.pack, icon: Crown, name: "Pack Bonus", text: `+${b.pack_bonus}% to every stat & the Pack Alpha title`, color: "text-amber-300", sample: "/art/alpha.webp" },
  ];
}

export default function BoostBadges({ boosts, settings, art = {}, compact = false }) {
  const active = boostList(boosts, settings).filter((x) => x.on);
  if (!active.length) return compact ? null : <p data-testid="no-boosts" className="text-xs text-slate-500">No NFT boosts active</p>;
  return (
    <TooltipProvider delayDuration={100}>
      <div className="flex flex-wrap gap-2" data-testid="boost-badges">
        {active.map((x) => (
          <Tooltip key={x.key}>
            <TooltipTrigger asChild>
              <span data-testid={`boost-badge-${x.key}`} className={`nft-glow inline-flex items-center gap-1.5 pl-0.5 pr-2.5 py-0.5 rounded-full border bg-gradient-to-r from-amber-950/80 via-slate-900 to-amber-900/60 text-xs ${x.color}`}>
                {art[x.key] || x.key === "pack" || x.key === "sol"
                  ? <img src={art[x.key] || x.sample} alt="" className="w-6 h-6 rounded-full object-cover border border-amber-400/60" />
                  : <x.icon className="w-3.5 h-3.5 ml-2" />}
                {compact ? <x.icon className="w-3.5 h-3.5" /> : x.name}
              </span>
            </TooltipTrigger>
            <TooltipContent><b>{x.name}</b>: {x.text}</TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}
